
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured",
      function () {
        return require("private-next-pages/featured/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/featured"])
      });
    }
  